import { Box, Grid, Heading, HStack, Image, Stack, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { INDUSTRIES } from 'const';

export const About: React.FC = () => {
  return (
    <Box py={16}>
      <Stack direction={{ base: 'column', lg: 'row' }} align="center">
        <VStack align="start" flex={1}>
          <Heading size="xl">CaspiPos Haqqında</Heading>

          <Text fontSize="lg" color="gray.600">
            CaspiPos hər ölçüdə biznes üçün nəzərdə tutulmuş satış sistemidir.
          </Text>

          <Text fontSize="md" color="gray.700" fontWeight={500}>
            POS platformamız aşağıdaki sahələrə xidmət göstərir:
          </Text>

          <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={4} w="100%">
            {INDUSTRIES.map((industry, index) => (
              <HStack key={index} align="start">
                <Box
                  w={5}
                  h={5}
                  borderRadius="full"
                  bg="green.500"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexShrink={0}
                  mt={0.5}
                >
                  <Text color="white" fontSize="xs" fontWeight="bold">
                    ✓
                  </Text>
                </Box>
                <Text fontSize="md" color="gray.700">
                  {industry}
                </Text>
              </HStack>
            ))}
          </Grid>

          <Text fontSize="md" color="gray.600" lineHeight="tall">
            Təhlükəsizlik, istifadə rahatlığı və hər tərəfli xüsusiyyətlərə diqqət yetirərək,
            CaspiPos bizneslərin satış, anbar, müştəri və maliyyə məlumatlarını bir yerdə idarə
            etməsinə kömək edir.
          </Text>
        </VStack>

        <Box flex={1} w="100%">
          <VStack maxW="700px" mx="auto">
            <Grid templateColumns="repeat(2, 1fr)" gap={4} w="100%">
              <Box
                bg="white"
                borderRadius="14px"
                border="2px solid"
                borderColor="gray.300"
                boxShadow="lg"
              >
                <Image borderRadius={'10px'} src="assets/dashboard.png" />
              </Box>
              <Box
                w={'300px'}
                bg="white"
                borderRadius="14px"
                border="2px solid"
                borderColor="gray.300"
                boxShadow="lg"
              >
                <Image width={'100%'} height={'100'} src="assets/app-image.png" />
              </Box>
            </Grid>

            <Grid templateColumns="repeat(2, 1fr)" gap={4} w="100%">
              <Box mx="auto" w="160px">
                <Image src="assets/mobile-image.png" />
              </Box>

              <Box mx="auto" w="160px">
                <Image src="assets/mobile-image-balance.png" />
              </Box>
            </Grid>
          </VStack>
        </Box>
      </Stack>
    </Box>
  );
};
